import * as React from "react";
import { Tooltip } from "@mui/material";

export const CustomActionRender = ({ action, row }) => {
  const duration = (action.end - action.start).toFixed(2);

  return (
    <Tooltip title={action.raw || action.label || ""} arrow>
      <div
        className="custom-action-box"
        style={{
          width: "100%",
          backgroundColor: "#3f51b5",
          borderRadius: 4,
          padding: "0 5px",
          height: "100%",
          display: "flex",
          alignItems: "center",
          color: "#fff",
          fontWeight: "600",
          fontSize: 8,
          cursor: "pointer",
          overflow: "hidden",
        }}
      >
        Player-{action?.raw?.split("-")?.[0]}-{action?.raw?.split("-")?.[1]} |{" "}
        {action.label} |
        {action?.raw?.split("-")?.[8] !== "X" &&
          "Sp.Act-" + action?.raw?.split("-")?.[8]}
      </div>
    </Tooltip>
  );
};
